"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _styles = _interopRequireDefault(require("./styles"));

var BannerMobileHeader = function BannerMobileHeader(props) {
  var onClose = props.onClose,
      titleLabel = props.titleLabel;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    nativeID: "widget-modal-header",
    style: _styles["default"].widgetModalHeader
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    onPress: onClose
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _styles["default"].headerCloseIcon
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: _crossPlatformComponents.AaIconTypes.ARROW_RIGHT,
      iconStyle: {
        height: 24,
        width: 24
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _styles["default"].headerTitle
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _styles["default"].headerTextStyle
  }, titleLabel)));
};

var _default = BannerMobileHeader;
exports["default"] = _default;